import { apiClient } from './apiClient';

export interface InverterPerformance {
  inverter_id: string;
  specific_yield: number;
  efficiency: number;
  pr: number;
  cuf: number;
  status: 'generating' | 'offline' | 'faulty' | 'maintenance';
  health_score: number;
  dc_power?: number;
  ac_power?: number;
  energy?: number;
}

export interface InverterPerformanceResponse {
  inverters: InverterPerformance[];
  summary: {
    total_inverters: number;
    avg_efficiency: number;
    avg_pr: number;
    avg_cuf: number;
    status_counts: Record<string, number>;
  };
}

export interface InverterStatusData {
  inverter_id: string;
  plant_name: string;
  status: string;
  health_score: number;
  last_updated: string;
}

export const inverterPerformanceService = {
  getInverterPerformance: async (
    date?: string, 
    plantId?: string, 
    status?: string
  ): Promise<InverterPerformanceResponse> => {
    const params = new URLSearchParams();
    if (date) params.append('date', date);
    if (plantId) params.append('plant_id', plantId);
    if (status) params.append('status', status);
    
    const response = await apiClient.get(`/api/monitoring/inverters/performance/?${params}`);
    return response.data;
  },

  getInverterStatus: async (date?: string) => {
    const params = new URLSearchParams();
    if (date) params.append('date', date);
    
    const response = await apiClient.get(`/api/monitoring/inverters/status/?${params}`);
    return response.data;
  }
};